import { Configuration, LogLevel } from '@azure/msal-browser';
import { clientId, authority, redirectUri, scopes } from './variables';

export const msalConfig: Configuration = {
    auth: {
        clientId: clientId,
        authority: authority,
        redirectUri: redirectUri,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message) => console.log(message),
            logLevel: LogLevel.Info,
        },
    },
};

export const loginRequest = {
    scopes: scopes
};
